import { connect } from "react-redux";
import { RootState } from "store/store";
import EnvironmentHistory from "./EnvironmentHistory";
import { setEnvironmentHistoryOpened } from "store/environments/environment-history/environment-history-actions";
import { getActiveEnvironmentMoniker } from "store/environments/environment-selectors";

const mapStateToProps = (state: RootState) => {
    return {
        envMoniker: getActiveEnvironmentMoniker(state),
        isOpened: state.environmentHistoryReducer.isOpened,
    };
};
const EnvironmentHistoryContainer = connect(mapStateToProps, {
    setActionHistoryOpened: setEnvironmentHistoryOpened,
})(EnvironmentHistory);

export default EnvironmentHistoryContainer;
